export enum CoachEducationLevel {
    'Higher National Diploma' = 0,
    'Bachelors Degree' = 1,
    'Masters Degree' = 2,
    'Post Graduate Certificate In Education' = 3,
    'Rather Not Say' = 4,
    'Other' = 5
}